var _desc, _defs, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVideoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1000,
    height: 1000,
    viewBox: "0 0 1000 1000",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Fabric.js 3.5.0")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: "100%",
    height: "100%",
    fill: "rgba(255,255,255,0)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(45.4545 0 0 45.4545 499.9995 499.9997)",
    id: 736021
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeDashoffset: 0,
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      isCustomFont: "none",
      fontFileUrl: "none",
      fill: "rgb(255,255,255)",
      fillRule: "nonzero",
      opacity: 0.84
    },
    vectorEffect: "non-scaling-stroke",
    transform: " translate(-12, -12)",
    d: "M 18 7 c 0 -1.103 -0.897 -2 -2 -2 H 4 c -1.103 0 -2 0.897 -2 2 v 10 c 0 1.103 0.897 2 2 2 h 12 c 1.103 0 2 -0.897 2 -2 v -3.333 L 22 17 V 7 l -4 3.333 V 7 z m -1.998 10 H 4 V 7 h 12 l 0.001 4.999 L 16 12 l 0.001 0.001 l 0.001 4.999 z",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideoWhite);
export default __webpack_public_path__ + "static/media/Video-White.10a3a4bd55c6236d0e0bf7ecc10af59b.svg";
export { ForwardRef as ReactComponent };